import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const Neo65Cu = () => (
  <ArticleWrapper articleId="neo65_cu">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Neo65 Cu</h1>
        <img src="/pictures/gallery/gallery10.JPG" alt="Neo65 Cu" className="rounded-lg mb-6" />
        {/* Add your Neo65 Cu article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default Neo65Cu;
